/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send you updates, newsletters, and marketing communications (with your consent)`)
};

const es_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviarte actualizaciones, boletines y comunicaciones de marketing (con tu consentimiento)`)
};

const de_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihnen Updates, Newsletter und Marketingmitteilungen zu senden (mit Ihrer Zustimmung)`)
};

const nl_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`U updates, nieuwsbrieven en marketingcommunicatie te sturen (met uw toestemming)`)
};

const fr_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous envoyer des mises à jour, newsletters et communications marketing (avec votre consentement)`)
};

const it_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviarti aggiornamenti, newsletter e comunicazioni di marketing (con il tuo consenso)`)
};

const pt_br2_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar atualizações, newsletters e comunicações de marketing (com seu consentimento)`)
};

const pt_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar-lhe atualizações, newsletters e comunicações de marketing (com o seu consentimento)`)
};

const ja_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新情報、ニュースレター、マーケティング通信の送信（同意がある場合）`)
};

const zh_privacy_use_4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向您发送更新、新闻通讯和营销通讯（经您同意）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_4", locale)
	if (locale === "en") return en_privacy_use_4(inputs)
	if (locale === "es") return es_privacy_use_4(inputs)
	if (locale === "de") return de_privacy_use_4(inputs)
	if (locale === "nl") return nl_privacy_use_4(inputs)
	if (locale === "fr") return fr_privacy_use_4(inputs)
	if (locale === "it") return it_privacy_use_4(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_4(inputs)
	if (locale === "pt") return pt_privacy_use_4(inputs)
	if (locale === "ja") return ja_privacy_use_4(inputs)
	return zh_privacy_use_4(inputs)
};